export const NAME = 'NAME';
export const EMAIL = 'EMAIL';
export const PHONE = 'PHONE';
export const CONTACT_PERSON = 'CONTACT_PERSON';
export const FAX = 'FAX';
export const COMPANY = 'COMPANY';
export const ADDRESS = 'ADDRESS';
export const NOTES = 'NOTES';

//Personnels
export const FIRST_NAME = 'FIRST_NAME';
export const LAST_NAME = 'LAST_NAME';
export const WORK_PHONE = 'WORK_PHONE';
export const BRANCH = 'BRANCH';
export const START_DATE_UTC = 'START_DATE_UTC';
export const HOME_PHONE = 'HOME_PHONE';
export const ASSIGNEE = 'ASSIGNEE';
export const REQUESTOR = 'REQUESTOR';
export const REG_DATE_UTC = 'REG_DATE_UTC';
export const SITE = 'SITE';

//Accident
export const INJURY_DATE = 'INJURY_DATE';
export const INJURY_TIME = 'INJURY_TIME';
export const DEPARTMENT = 'DEPARTMENT';
export const INJURY_LOCATION = 'INJURY_LOCATION';
export const INJURY_TYPE = 'INJURY_TYPE';
export const PERSONNEL = 'PERSONNEL';
export const INJURY_CAUSE = 'INJURY_CAUSE';
export const TREATMENT = 'TREATMENT';
export const WHAT_HAPPENEND = 'WHAT_HAPPENEND';
export const CAUSE = 'CAUSE';
export const ASSESSMENT = 'ASSESSMENT';
export const ANALYSIS = 'ANALYSIS';
export const ACTION = 'ACTION';
export const ACCIDENT_ATTACHMENT = 'ACCIDENT_ATTACHMENT';

//Events
export const DESCRIPTION = 'DESCRIPTION';
export const EVENT_NOTES = 'EVENT_NOTES';
export const FREQUENCY = 'FREQUENCY';
export const EVENT_TYPE = 'EVENT_TYPE';
export const EVENT_COORDINATOR = 'EVENT_COORDINATOR';
export const LAST_HELD_DATE = 'LAST_HELD_DATE';
export const NEXT_EVENT_DATE = 'NEXT_EVENT_DATE';
export const EVENT_DOCUMENT_NAME = 'EVENT_DOCUMENT_NAME';

//Records
export const RECORD_DATE = 'RECORD_DATE';
export const RECORD_NOTES = 'RECORD_NOTES';
export const EVENT_RECORD_ATTACHMENT = 'EVENT_RECORD_ATTACHMENT';

//Hazards
export const INITIAL_RISK_LIKELIHOOD = 'INITIAL_RISK_LIKELIHOOD';
export const INITIAL_RISK_CONSEQUENCE = 'INITIAL_RISK_CONSEQUENCE';
export const INITIAL_SCORE = 'INITIAL_SCORE';
export const FINAL_RISK_LIKELIHOOD = 'FINAL_RISK_LIKELIHOOD';
export const FINAL_RISK_CONSEQUENCE = 'FINAL_RISK_CONSEQUENCE';
export const FINAL_SCORE = 'FINAL_SCORE';
export const NEXT_REVIEW_DATE = 'NEXT_REVIEW_DATE';
export const HAZARD_STATUS = 'HAZARD_STATUS';
export const HAZARD_DOCUMENT = 'HAZARD_DOCUMENT';
export const HAZARD_DEPARTMENT = 'HAZARD_DEPARTMENT';

//Controls
export const CONTROL_COMMENTS = 'CONTROL_COMMENTS';
export const CONTROL_HIERARCHY = 'CONTROL_HIERARCHY';

//Course record
export const PERSONNEL_ID = 'PERSONNEL_ID';
export const COURSE_RECORD_ATTACHMENT = 'COURSE_RECORD_ATTACHMENT';

//Courses
export const UNIT_DESCRIPTION = 'UNIT_DESCRIPTION';
export const COURSE_CODE = 'COURSE_CODE';
export const TRAINING_PROVIDER = 'TRAINING_PROVIDER';
export const CONTACT_PERSON_FOR_COURSE = 'CONTACT_PERSON_FOR_COURSE';
export const PHONE_FOR_COURSE = 'PHONE_FOR_COURSE';
export const EMAIL_FOR_COURSE = 'EMAIL_FOR_COURSE';
export const COURSE_COST = 'COURSE_COST';
export const DURATION = 'DURATION';
export const FREQUENCY_FOR_COURSE = 'FREQUENCY_FOR_COURSE';
export const COURSE_CATEGORY = 'COURSE_CATEGORY';
export const COURSE = 'COURSE';
export const COURSE_DOCUMENT = 'COURSE_DOCUMENT';
export const COURSE_NOTES = 'COURSE_NOTES';

//User
export const USER_NAME = 'USER_NAME';
export const USER_EMAIL = 'USER_EMAIL';
export const USER_PASSWORD = 'USER_PASSWORD';
export const USER_ROLE = 'USER_ROLE';
export const USER_BRANCH = 'USER_BRANCH';
export const USER_COMPANY = 'USER_COMPANY';

//HazardReview
export const REVIEW_DESCRIPION = 'REVIEW_DESCRIPION';
export const REVIEW_REVIEW_DATE = 'REVIEW_REVIEW_DATE';

//HazardManagementLog
export const LOG_DESCRIPION = 'LOG_DESCRIPION';
export const LOG_DATE = 'LOG_DATE';

//Attachment
export const HAZARD_ATTACHMENT = 'HAZARD_ATTACHMENT';
export const HAZARD_REVIEW_ATTACHMENT = 'HAZARD_REVIEW_ATTACHMENT';
export const HAZARD_MANAGEMENT_LOGS_ATTACHMENT =
  'HAZARD_MANAGEMENT_LOGS_ATTACHMENT';
export const HAZARD_CONTROL_ATTACHMENT = 'HAZARD_CONTROL_ATTACHMENT';
export const HAZARD_CONTROL_DOCUMENT = 'HAZARD_CONTROL_DOCUMENT';

export default {
  NAME,
  EMAIL,
  PHONE,
  CONTACT_PERSON,
  FAX,
  COMPANY,
  ADDRESS,
  NOTES,

  //Attachements
  HAZARD_ATTACHMENT,
  HAZARD_REVIEW_ATTACHMENT,
  HAZARD_MANAGEMENT_LOGS_ATTACHMENT,
  HAZARD_CONTROL_ATTACHMENT,


  //Personnels
  FIRST_NAME,
  LAST_NAME,
  WORK_PHONE,
  BRANCH,
  START_DATE_UTC,
  HOME_PHONE,
  ASSIGNEE,
  REQUESTOR,
  REG_DATE_UTC,
  SITE,

  //Accident
  INJURY_DATE,
  INJURY_TIME,
  DEPARTMENT,
  INJURY_LOCATION,
  INJURY_TYPE,
  PERSONNEL,
  INJURY_CAUSE,
  TREATMENT,
  WHAT_HAPPENEND,
  CAUSE,
  ASSESSMENT,
  ANALYSIS,
  ACTION,
  ACCIDENT_ATTACHMENT,

  //Events
  DESCRIPTION,
  EVENT_NOTES,
  FREQUENCY,
  EVENT_TYPE,
  EVENT_COORDINATOR,
  LAST_HELD_DATE,
  NEXT_EVENT_DATE,
  EVENT_DOCUMENT_NAME,

  //Records
  RECORD_DATE,
  RECORD_NOTES,
  EVENT_RECORD_ATTACHMENT,

  //Hazards
  INITIAL_RISK_LIKELIHOOD,
  INITIAL_RISK_CONSEQUENCE,
  FINAL_RISK_LIKELIHOOD,
  FINAL_RISK_CONSEQUENCE,
  NEXT_REVIEW_DATE,
  HAZARD_STATUS,
  HAZARD_DOCUMENT,
  HAZARD_DEPARTMENT,

  //Controls
  CONTROL_COMMENTS,
  CONTROL_HIERARCHY,
  HAZARD_CONTROL_DOCUMENT,

  //Review
  REVIEW_DESCRIPION,
  REVIEW_REVIEW_DATE,

  //ManagemenLog
  LOG_DESCRIPION,
  LOG_DATE,

  //Course record
  PERSONNEL_ID,
  COURSE_RECORD_ATTACHMENT,

  //Courses
  UNIT_DESCRIPTION,
  COURSE_CODE,
  TRAINING_PROVIDER,
  CONTACT_PERSON_FOR_COURSE,
  PHONE_FOR_COURSE,
  EMAIL_FOR_COURSE,
  COURSE_COST,
  DURATION,
  FREQUENCY_FOR_COURSE,
  COURSE_CATEGORY,
  COURSE,
  COURSE_NOTES,
  COURSE_DOCUMENT,

  //User
  USER_NAME,
  USER_EMAIL,
  USER_PASSWORD,
  USER_ROLE,
  USER_BRANCH,
  USER_COMPANY
};
